import React, { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './Careers.css';

const Careers = () => {
  const [searchParams] = useSearchParams();
  const showJobDetails = searchParams.get('job') === 'sales-specialist';
  const headingRef = useRef(null);
  const previousView = useRef(showJobDetails);

  useEffect(() => {
    if (previousView.current !== showJobDetails) {
      headingRef.current?.focus();
      previousView.current = showJobDetails;
    }
  }, [showJobDetails]);

  return (
    <div className="careers-page">
      <header className="careers-header">
        <h1>Careers</h1>
        <p>We believe in the power of play to drive deeper customer engagement. Our people make it possible.</p>
      </header>

      <section
        className="openings-section"
        aria-labelledby={showJobDetails ? 'sales-specialist-title' : 'openings-title'}
      >
        {showJobDetails ? (
          <article className="job-posting" aria-labelledby="sales-specialist-title">
            <Link className="job-back-link" to="/careers">
              <span aria-hidden="true">← </span>Back to all openings
            </Link>
            <h2 id="sales-specialist-title" className="job-view-title" ref={headingRef} tabIndex={-1}>
              Sales Specialist
            </h2>
            <p>
              Our Company is growing and we are looking for a <strong>Sales Specialist</strong>,
              someone who understands technology, thrives on building relationships, and has
              a passion for turning meaningful conversations into valuable business opportunities.
            </p>

            <section className="job-section" aria-labelledby="job-description-title">
              <h3 id="job-description-title">Job Description</h3>
              <p>
                This role is about more than just hitting sales targets. You’ll be responsible
                for building relationships with clients, understanding their business challenges,
                identifying where we can add value, and working with our technical teams to put
                the right solutions in front of them.
              </p>
              <p>
                You should be comfortable sitting across the table from a CEO, CTO, or other
                senior decision-maker and having a meaningful conversation about their business
                and technology needs. You’ll also play an important role in helping shape our
                sales strategy and identifying opportunities for the company to grow.
              </p>
            </section>

            <section className="job-section" aria-labelledby="job-responsibilities-title">
              <h3 id="job-responsibilities-title">What you’ll be doing</h3>
              <ul>
                <li>Identify and develop new business opportunities for our products &amp; solutions.</li>
                <li>Lead the sales process from the initial conversation through to proposal, negotiation, and closing.</li>
                <li>Work closely with our technical and delivery teams to develop solutions that genuinely address client needs.</li>
                <li>Manage key accounts and look for opportunities to grow existing relationships.</li>
                <li>Prepare and deliver proposals, presentations, and solution demonstrations.</li>
                <li>Keep the sales pipeline healthy and provide realistic forecasts on upcoming opportunities.</li>
                <li>Stay aware of changes in the technology market, customer needs, and competitor activity.</li>
                <li>Help solve customer issues and make sure clients have a positive experience working with us.</li>
                <li>Bring customer and market insights back to the business and contribute to decisions around our growth and direction.</li>
              </ul>
            </section>

            <section className="job-section" aria-labelledby="job-qualifications-title">
              <h3 id="job-qualifications-title">Qualifications</h3>
              <ul>
                <li>
                  A Bachelor’s degree in <strong>Software Engineering, Information Technology,
                  Business Studies, Business Administration, Marketing, or a related field</strong>.
                </li>
                <li>
                  <strong>3-5 years of experience in a technology company</strong>, ideally in
                  sales, account management, business development, or solution sales.
                </li>
                <li>A proven track record of winning business and meeting sales targets.</li>
                <li>Strong communication skills and the confidence to engage with senior executives.</li>
                <li>Someone who is naturally good at building and maintaining relationships.</li>
                <li>Strong solution-selling and consultative sales skills.</li>
                <li>Good problem-solving skills and commercial acumen.</li>
              </ul>
            </section>

            <section className="job-section" aria-labelledby="job-apply-title">
              <h3 id="job-apply-title">How to apply</h3>
              <p>
                Email your CV to{' '}
                <a className="job-email-link" href="mailto:info@peakmobile.co.ke">
                  info@peakmobile.co.ke
                </a>.
              </p>
            </section>
          </article>
        ) : (
          <>
            <h2 id="openings-title" className="job-view-title" ref={headingRef} tabIndex={-1}>
              Current Openings
            </h2>
            <div className="job-card-grid">
              <Link
                className="job-card"
                to="/careers?job=sales-specialist"
                aria-labelledby="sales-specialist-card-title"
              >
                <h3 id="sales-specialist-card-title">Sales Specialist</h3>
                <p>
                  Our Company is growing and we are looking for a <strong>Sales Specialist</strong>,
                  someone who understands technology, thrives on building relationships, and has
                  a passion for turning meaningful conversations into valuable business opportunities.
                </p>
                <span className="job-card-action">
                  View role <span aria-hidden="true">→</span>
                </span>
              </Link>
            </div>
          </>
        )}
      </section>
    </div>
  );
};

export default Careers;
